import {IApplicationState} from '../../../../types/types';
import {getAuthUser} from './getAuthUser';

export const getUnseenNotificationCount = (
    state: IApplicationState
) => {
    return getAuthUser(state).unseenNotificationCount
}
